import { Checkbox, Dialog, type DialogRef } from '@myosh/odin-components';
import { type Ref, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AiAnalysisConfirmationModalProps {
  handleSubmitConfirmation: (value: boolean) => void;
  ref?: Ref<DialogRef>;
}

const AiAnalysisConfirmationModal = ({ handleSubmitConfirmation, ref }: AiAnalysisConfirmationModalProps) => {
  const { t } = useTranslation();
  const [isAiAnalysisConfirmationCheckboxChecked, setIsAiAnalysisConfirmationCheckboxChecked] = useState(false);

  return (
    <Dialog
      data-cy="ai-analysis-confirmation-modal"
      buttons={[
        {
          name: 'submit',
          text: 'Ok',
          onClick: () => handleSubmitConfirmation(isAiAnalysisConfirmationCheckboxChecked),
        },
      ]}
      header={t(($) => $.aiAnalysis)}
      ref={ref}
    >
      <div className="flex flex-col gap-4">
        <p className="font-semibold text-lg">
          Warning: Data is sent to an external AI. Verify all AI results for accuracy.
        </p>
        <Checkbox
          data-cy="ai-analysis-confirmation-checkbox"
          name="show-ai-analysis-confirmation"
          label="Don’t show me again"
          checked={isAiAnalysisConfirmationCheckboxChecked}
          onChange={(value) => setIsAiAnalysisConfirmationCheckboxChecked(value.checked)}
        />
      </div>
    </Dialog>
  );
};

export default AiAnalysisConfirmationModal;
